// extracted by mini-css-extract-plugin
export var layoutContainer = "_9i-0";
export var layoutContainerNoRounding = "_9i-6";
export var layoutContainerOpen = "_9i-5";
export var layoutContainerResizing = "_9i-1";
export var mainContent = "_9i-2";
export var resizeDivider = "_9i-3";
export var slidePanel = "_9i-4";